import QuickSearch from "./QuickSearch";
import Wallpaper from "./Wallpaper";

function HomePage() {
  return (
    <>
      <Wallpaper />
      <QuickSearch />
    </>
  );
}
export default HomePage;
